import { createI18n } from '@workingclock/i18n';

import marketingDe from './marketing.de.json';
import marketingEn from './marketing.en.json';
import marketingEs from './marketing.es.json';
import marketingFr from './marketing.fr.json';
import marketingIt from './marketing.it.json';

/**
 * Adds this app's screen-specific copy on top of the shared common/auth/timer
 * namespaces — mirrors apps/webapp/src/i18n/index.ts's pattern, with a
 * 'marketing' namespace instead of 'webapp'.
 *
 * Unlike the webapp (a pure client SPA), the marketing site is pre-rendered
 * (SSG, vite-react-ssg). The pre-render always runs in English (the Node build
 * has no browser locale — `readStoredLanguage()` falls back to 'en'), so the
 * client's FIRST render must also be English or hydration mismatches on every
 * translated string. We therefore pin the initial language to 'en' here and
 * switch to the visitor's stored/browser language after hydration — see
 * RootLayout's effect. English is also the canonical (indexed) language.
 */
export const i18n = createI18n({
  lng: 'en',
  extraResources: {
    en: { marketing: marketingEn },
    it: { marketing: marketingIt },
    de: { marketing: marketingDe },
    fr: { marketing: marketingFr },
    es: { marketing: marketingEs },
  },
});
